import {
  gql
} from "@apollo/client"

export const SAVE_REFERENCE_CLICKS = gql`
    mutation SaveReferenceClicks($source: String!, $code: String!) {
        saveReferenceClicks(input: { source: $source, code: $code }) {
            code
            message
            content
        }
    }
`
